export const EVENT_ISSUABLE_VUE_APP_CHANGE = 'issuable_vue_app:change';

export const ISSUABLE_TYPE = {
  issues: 'issues',
  mergeRequests: 'merge-requests',
};

export const ISSUABLE_INDEX = {
  ISSUE: 'issue_',
  MERGE_REQUEST: 'merge_request_',
};
